module.exports = __webpack_public_path__ + "media/images/japan/location_4-51d4599e5a4eaf73e2b9814d20623cdf.png";